module.exports = __webpack_public_path__ + "static/media/room-7.a9f65980.jpeg";